import { render, staticRenderFns } from "./WanderManagement.vue?vue&type=template&id=d5d846ca&scoped=true&"
import script from "./WanderManagement.vue?vue&type=script&lang=js&"
export * from "./WanderManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d846ca",
  null
  
)

export default component.exports